import { Consumer } from '../Context'

export default function Confirm() {
  return (
    <Consumer>
      {(props) => (
        <form>
          <div className="form-group">
            <span>
              You have successfully checked in, an ATG staff member will be with you shortly!
            </span>
          </div>
          <br />
          <button type="button" onClick={props.resetForm} className="d-flex btn btn-primary ml-auto px-5">
            Okay
          </button>
        </form>
      )}
    </Consumer>
  )
}
